import React from "react";
//#region types
import { FormFieldGroupProps, GenericFormField } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import FormFieldWrapper from "../formFieldWrapper";
import { Grid } from "@mui/material";
import { useFormikContext } from "formik";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance, FormHelper } from "utils/helpers";

function FormFieldGroup<T extends Record<string, any>>(props: FormFieldGroupProps<T>) {
  const { field, layout } = props;
  const { values } = useFormikContext<T>();

  const gerFieldGroupContent = (innerFields: Partial<Record<string, GenericFormField<T>>>) => (
    <>
      {Object.entries(innerFields).map(([key, field], index) =>
        field ? (
          <Grid key={`formGroupField-${index}`} item xs={field.widthColumnCount ?? 6}>
            <FormFieldWrapper<T>
              {...props}
              name={key}
              field={{ ...field, widthColumnCount: undefined }}
              messagePlacement="top"
              hideOptionalIndicator={FormHelper.evaluateHideOptionalIndicator(field.hideOptionalIndicator, values)}
            />
            {!field.readonly && field.descriptionText && (
              <Grid item className={clsx(cssExports.formControlDescription, cssExports.verticalFormDescription)}>
                {typeof field.descriptionText === "string"
                  ? LocalizationHelperInstance.getFormattedMessage(field.descriptionText, field.descriptionText)
                  : field.descriptionText}
              </Grid>
            )}
          </Grid>
        ) : (
          <></>
        )
      )}
    </>
  );

  return field.innerFields ? (
    layout ? (
      <layout.type key={layout.key} {...layout.props} names={Object.keys(field.innerFields)}>
        <Grid container direction="row" spacing={1}>
          {gerFieldGroupContent(field.innerFields)}
        </Grid>
      </layout.type>
    ) : (
      gerFieldGroupContent(field.innerFields)
    )
  ) : (
    <></>
  );
}

export default FormFieldGroup;
